import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Document upload routes
const DocumentUploadPage = lazy(
  () =>
    import(
      "@/features/student-view/document-upload/pages/student-document-upload"
    )
);
const StudentDocumentListPage = lazy(
  () =>
    import(
      "@/features/student-view/document-upload/pages/student-document-list"
    )
);
const DocumentDetailsPage = lazy(
  () => import("@/shared/documents/document-details")
);

export const documentsRoutes: RouteObject[] = [
  {
    path: "/documents/file-upload",
    element: <DocumentUploadPage />,
  },
  {
    path: "/documents",
    element: <StudentDocumentListPage />,
  },
  {
    path: "/documents/list/:id",
    element: <DocumentDetailsPage isStudent={true} />,
  },
  {
    path: "/documents/file-upload/edit/:id",
    element: <DocumentUploadPage />,
  },
];
